import FairMarketRangeSheet from './FairMarketRangeSheet';

export default FairMarketRangeSheet;
